module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "title",
      rawName: "v-title",
      value: ('齐齐直播'),
      expression: "'齐齐直播'"
    }],
    staticClass: "dt"
  }, [_c('navtop', {
    attrs: {
      "index": 'dating'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('i', {
    staticClass: "iconfont",
    on: {
      "click": _vm.showSearch
    }
  }, [_vm._v("")]), _vm._v(" "), (_vm.searchShow) ? _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "searchCon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchId),
      expression: "searchId"
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (_vm.searchShow),
      expression: "searchShow"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "请输入6位房间号"
    },
    domProps: {
      "value": (_vm.searchId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.searchRoom
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/dating/search2.png")
    }
  })])]), _vm._v(" "), _c('i')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabWrap"
  }, [_c('ul', [_c('li', {
    class: {
      cur: _vm.navIndex == 1
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 1
      }
    }
  }, [_c('a', [_vm._v("大厅")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 5
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 5
      }
    }
  }, [_c('a', [_vm._v("女神")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 2
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 2
      }
    }
  }, [_c('a', [_vm._v("新人")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 3
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 3
      }
    }
  }, [_c('a', [_vm._v("好声音")])]), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.navIndex == 4
    },
    on: {
      "click": function($event) {
        _vm.navIndex = 4
      }
    }
  }, [_c('a', [_vm._v("型男")])])])]), _vm._v(" "), (_vm.popTips || _vm.tips.con) ? _c('div', {
    staticClass: "pop"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips.con))]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.confirmTips
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.closeTips
    }
  }, [_vm._v("x")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "anchorList",
    style: ('height:' + _vm.scrollHeight + ';overflow:scroll;-webkit-overflow-scrolling: touch;')
  }, [_c('ul', [_vm._l((_vm.showList), function(item, index) {
    return (index < _vm.lazyImg) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.checkLogin(item.roomId)
        }
      }
    }, [_c('img', {
      staticClass: "pic",
      attrs: {
        "src": typeof item.anchorPic == 'object' ? ('https://qiqi-resource-v6.qxiu.com' + item.anchorPic[0].slice(29)) : ('https://qiqi-resource-v6.qxiu.com' + JSON.parse(item.anchorPic)[0].slice(29))
      }
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.subString(item.anchorName, 9, true))), _c('span', [_c('img', {
      staticClass: "viewer",
      attrs: {
        "src": require("../../img/dating/viewer.png")
      }
    }), _vm._v(_vm._s(item.roomNum))])]), _vm._v(" "), (item.happyPk == 0) ? _c('span', {
      staticClass: "label"
    }) : _vm._e(), _vm._v(" "), (item.happyPk != 0) ? _c('span', {
      staticClass: "labelPk"
    }) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.loadingMore) ? _c('li', {
    staticClass: "loadingMore"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/dating/loading.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("加载中..")])]) : _vm._e()], 2)]), _vm._v(" "), _c(_vm.curview, {
    tag: "component"
  }), _vm._v(" "), (_vm.loadingImg) ? _c('div', {
    staticClass: "loadingImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../img/dating/loading.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("加载中..")])]) : _vm._e(), _vm._v(" "), (_vm.isxiaoxiong) ? _c('div', {
    staticClass: "downEntry",
    style: ('background:url(https://static.qxiu.com/h5/static/down3.png);background-size:4.68rem 2.08rem;display:' + (!_vm.isAndroid && _vm.isYouxi ? 'none' : 'block')),
    on: {
      "click": _vm.download
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isxiaoxiong) ? _c('div', {
    staticClass: "downEntry2",
    on: {
      "click": _vm.download
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isYouxi) ? _c('div', {
    staticClass: "backGame",
    on: {
      "click": _vm.backGame
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowTgy) ? _c('div', {
    staticClass: "tg202102",
    on: {
      "click": function($event) {
        _vm.isShowTgy = false
      }
    }
  }, [_c('div', {
    staticClass: "content",
    on: {
      "click": _vm.toRegist
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56bf302c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/index.vue
// module id = 124
// module chunks = 0